/** global google */

import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useOperation } from "../Context/OperationContext";

import icoPending from "../assets/img/location celeste 2.svg";
import iconProcess from "../assets/img/location verde 2.svg";
import iconFinish from "../assets/img/location naranja 2.svg";
import iconIncident from "../assets/img/location rojo.svg";

const MapsOperation = ({ handleInfoOpen, infoOpen }) => {
  const { operationData } = useOperation();
  const [selectedPlace, setSelectedPlace] = useState(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  // Effect to handle initial coordinates and updates
  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.state && mapRef.current.state.map) {
        fitBounds(mapRef.current.state.map);
      }
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operationData.coordMap]);

  const refmap = (ref) => {
    mapRef.current = ref;
  };

  const refmarker = (ref) => {
    markerRef.current = ref;
  };

  const fitBounds = async (map) => {
    try {
      // Make sure we have a valid map and coordinates
      if (!map || !operationData.coordMap) return;
      
      // Only proceed if we have coordinates to work with
      if (operationData.coordMap.length > 0) {
        const bounds = new window.google.maps.LatLngBounds();      
        operationData.coordMap.forEach(place => {
          if (place && place.coord && 
              typeof place.coord.lat === 'number' && 
              typeof place.coord.lng === 'number' &&
              !isNaN(place.coord.lat) && !isNaN(place.coord.lng)) {
            bounds.extend(place.coord);
          }
        });
        
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          map.setCenter(bounds.getCenter());
          map.setZoom(11);
        } else {
          map.fitBounds(bounds, { padding: 50 });
        }
      }
    } catch (error) {
      console.error('Error fitting bounds:', error);
    }
  };

  const loadHandler = async (map) => {
    await fitBounds(map);
  };

  const markerClickHandlerOpen = async (e, data) => {
    setSelectedPlace(data);

    // Required so clicking a 2nd marker works as expected
    if (infoOpen) {
      await handleInfoOpen(false);
    }
    await handleInfoOpen(true);
    if (mapRef.current.state.map) {
      await fitBounds(mapRef.current.state.map);
    }
  };

  const markerClickHandlerClose = async (e, data) => {
    await handleInfoOpen(false);
    if (mapRef.current.state.map) {
      await fitBounds(mapRef.current.state.map);
    }
  };

  const markerLoadHandler = async (marker, i) => {
    // Marker load handling logic if needed
  };

  return (
    <GoogleMap
      mapContainerClassName="App-map"
      onLoad={loadHandler}
      ref={refmap}
      center={{ lat: -16.5520373, lng: -71.6475389 }}
      zoom={14}
      options={{
        streetViewControl: false,
        mapTypeId: "satellite"
      }}
      mapContainerStyle={{
        height: "100%",
        width: "100%"
      }}
    >
      {operationData.coordMap.map((dat, i) => {
        const icons =
          dat.status === "Pendiente"
            ? iconFinish
            : dat.status === "Process"
            ? icoPending
            : dat.status === "lastPoint"
            ? iconFinish
            : dat.status === "nextPoint"
            ? iconProcess
            : dat.status === "Incidente"
            ? iconIncident
            : iconProcess;
        let label = dat.id.toString();
        return (
          <Marker
            key={i}
            ref={refmarker}
            onLoad={marker => markerLoadHandler(marker, dat.id)}
            onClick={e => markerClickHandlerOpen(e, dat)}
            title={dat.id.toString()}
            label={{
              text: label,
              color: "#000",
              fontSize: "14px",
              fontWeight: "bold"
            }}
            icon={{
              url: icons,
              size: new window.google.maps.Size(51, 51),
              origin: new window.google.maps.Point(-7, -5),
              anchor: new window.google.maps.Point(77, 74),
              scaledSize: new window.google.maps.Size(40, 40)
            }}
            position={dat.coord}
          ></Marker>
        );
      })}
      {infoOpen && selectedPlace && (
        <InfoWindow
          position={selectedPlace.coord}
          onCloseClick={markerClickHandlerClose}
          options={{
            pixelOffset: new window.google.maps.Size(-50, -75)
          }}
        >
          <div className="info-window">
            <h3 style={{ margin: "0px" }}>{selectedPlace.id}</h3>
            <h3 style={{ margin: "0px" }}>
              {selectedPlace.name !== null
                ? selectedPlace.name
                : ""}
            </h3>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default MapsOperation;
